export const toCircledNum = (num: number): string => {
  const base = '①'.charCodeAt(0)
  return String.fromCharCode(base + num - 1)
}
